module.exports = __webpack_public_path__ + "static/media/vsepravilno.5e2fc560.jpg";